// HomePage.jsx
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import StoreBadges from '../components/StoreBadges';
import { subscribeToWaitingPlayers } from '../lib/arenaStorage';
import { PUZZLES } from '../lib/puzzles';
import { useLang } from '../i18n';
import { SITE_URL, SOCIAL, PLAY_STORE_URL, CHROME_EXTENSION_URL } from '../config/links';

const C = {
  tr: {
    seoTitle: 'Şogi Türkiye — Japon Satrancı Öğren, Oyna ve Bulmaca Çöz',
    seoDesc: 'Japon satrancı şogiyi Türkçe öğrenin: kurallar, taşlar, 4 zorluk seviyesinde bilgisayara karşı oyun, tsume bulmacaları ve online arena. Ücretsiz, kayıt gerekmez.',
    eyebrow: 'Şogi Türkiye · Ücretsiz Japon Satrancı',
    h1a: 'Öğren, oyna,',
    h1b: 'kazan.',
    h1c: 'Japon satrancı tek adreste.',
    lead: "Şogiyi sıfırdan Türkçe öğren, dört zorluk seviyesinde bilgisayara karşı oyna, tsume bulmacalarıyla taktik gücünü artır ve Arena'da gerçek rakiplerle karşılaş. Reklam yok, kayıt zorunlu değil.",
    ctaPlay: 'Hemen Oyna',
    ctaPuzzle: 'Bulmaca Çöz',
    stats: [['4', 'zorluk seviyesi'], ['{p}', 'mat bulmacası'], ['2', 'dil: TR / EN'], ['0 ₺', 'tamamen ücretsiz']],
    playTitle: 'Tarayıcıda Oyna',
    allModes: 'Tüm modlar',
    cards: {
      play: ['Bilgisayara Karşı', "Kolaydan Usta'ya dört seviyede yapay zekâya karşı oyna. Hamle geçmişi ve terfi desteği.", 'Tek kişilik'],
      puzzles: ['Tsume Bulmacaları', '1, 3 ve 5 hamlede mat problemleri. İpucu al, çözümü adım adım gör.', 'Tek kişilik'],
      arena: ['Şogi Arena', 'Gerçek oyunculara karşı online maç. Hızlı eşleşme, canlı tahta.', '2 kişi'],
      academy: ['Şogi Akademi', 'Başlangıç rehberi, özel kurallar ve sık yapılan hatalar tek yerde.', 'Rehber'],
    },
    waiting: '{n} rakip bekliyor',
    learnTitle: 'Şogiyi Öğren',
    learn: {
      howto: ['Nasıl Oynanır?', 'Amaç, sıra ve bir hamlenin adımları.'],
      pieces: ['Şogi Taşları', '8 taş, hareketleri ve terfi biçimleri.'],
      rules: ['Kurallar', 'Terfi, elden taş sürme, nifu ve uchifuzume.'],
      faq: ['Sık Sorulan Sorular', '25+ soru ve cevap.'],
    },
    promoTitle: 'Şogi cebinde ve tarayıcında',
    promoText: 'Android uygulamamızla her yerde oyna, Chrome eklentimizle tarayıcıdan tek tıkla oyun aç.',
    promoMore: 'Uygulamalar hakkında',
    aboutTitle: 'Şogi nedir?',
    about: [
      ['Şoginin Kökeni', "Şogi (将棋), kökleri Hindistan'da doğan çaturangaya dayanan Japon satrancıdır. Bu oyun ailesi İpek Yolu üzerinden Çin'e ulaştığında xiangqi'ye, Güneydoğu Asya'da makruk gibi varyantlara dönüştü. Japonya'ya muhtemelen 8. ile 10. yüzyıllar arasında ulaştı; en eski yazılı kayıtlar Heian dönemine, 11. yüzyıla uzanır. Bugün oynanan modern biçim büyük ölçüde 16. yüzyılda şekillendi."],
      ['Ele Geçirilen Taşları Yeniden Kullanma', "Şogiyi diğer satranç varyantlarından ayıran en önemli kural elden taş sürmedir: ele geçirilen taş oyundan çıkmaz, onu alan oyuncunun emrine geçer ve tekrar tahtaya sürülebilir. Bu kural oyuna sürekli bir materyal döngüsü ve son derece taktiksel, saldırgan bir karakter kazandırır."],
      ["Japonya'da ve Dünyada Şogi", "Şogi Japonya'da satranç ve go ile birlikte en popüler zihin oyunlarındandır. Japonya Şogi Birliği (日本将棋連盟) profesyonel oyuncuları (棋士, kishi) derecelendirir ve turnuvaları düzenler. Son yıllarda yapay zekâ destekli şogi motorları profesyonellerin hazırlık yöntemlerini kökten değiştirdi."],
    ],
  },
  en: {
    seoTitle: 'Shogi Türkiye — Learn, Play and Solve Japanese Chess Puzzles',
    seoDesc: 'Learn shogi (Japanese chess) for free: rules, pieces, play the computer at 4 difficulty levels, solve tsume mate puzzles and play online in the Arena. No sign-up required.',
    eyebrow: 'Shogi Türkiye · Free Japanese Chess',
    h1a: 'Learn, play,',
    h1b: 'win.',
    h1c: 'Japanese chess in one place.',
    lead: 'Learn shogi from scratch, play the computer at four difficulty levels, sharpen your tactics with tsume puzzles and meet real opponents in the Arena. No ads, no mandatory sign-up.',
    ctaPlay: 'Play Now',
    ctaPuzzle: 'Solve a Puzzle',
    stats: [['4', 'difficulty levels'], ['{p}', 'mate puzzles'], ['2', 'languages'], ['$0', 'completely free']],
    playTitle: 'Play in your browser',
    allModes: 'All modes',
    cards: {
      play: ['Play the Computer', 'Four AI levels from Easy to Expert. Move history and promotion support.', 'Single player'],
      puzzles: ['Tsume Puzzles', 'Mate-in-1, 3 and 5 problems. Get hints and see the solution step by step.', 'Single player'],
      arena: ['Shogi Arena', 'Online games against real players. Quick matchmaking, live board.', '2 players'],
      academy: ['Shogi Academy', 'Beginner guide, special rules and common mistakes in one place.', 'Guide'],
    },
    waiting: '{n} waiting',
    learnTitle: 'Learn Shogi',
    learn: {
      howto: ['How to Play', 'Goal, turn order and how a move works.'],
      pieces: ['Shogi Pieces', 'The 8 pieces, how they move and promote.'],
      rules: ['Rules', 'Promotion, drops, nifu and uchifuzume.'],
      faq: ['FAQ', '25+ questions and answers.'],
    },
    promoTitle: 'Shogi in your pocket and your browser',
    promoText: 'Play anywhere with our Android app, or open a game with one click from our Chrome extension.',
    promoMore: 'About our apps',
    aboutTitle: 'What is shogi?',
    about: [
      ['Origins', 'Shogi (将棋) is Japanese chess, descended from the Indian game chaturanga. As this family of games travelled the Silk Road it became xiangqi in China and makruk in Southeast Asia. It probably reached Japan between the 8th and 10th centuries; the earliest written records date to the 11th-century Heian period, and the modern rules took shape largely in the 16th century.'],
      ['Captured pieces come back', "Shogi's defining rule is the drop: a captured piece is not removed from the game but joins the capturer's side and can be placed back on the board. This keeps material in constant circulation and gives shogi its sharp, attacking character."],
      ['Shogi in Japan and worldwide', 'In Japan shogi is one of the most popular mind games alongside go and chess. The Japan Shogi Association (日本将棋連盟) ranks professional players (棋士, kishi) and runs the major title matches. In recent years AI engines have transformed how professionals study and prepare.'],
    ],
  },
};

function HeroBoard() {
  // Dekoratif mini tahta (5×5 parça): koma şeklinde taşlar
  const cells = [
    ['', '', 'G', 'K', 'G'],
    ['', '', '', 'S', ''],
    ['P', 'P', 'P', '', 'P'],
    ['', '', '', 'P', ''],
    ['', 'B', '', '', 'R'],
  ];
  const kanji = { K: '王', G: '金', S: '銀', P: '歩', B: '角', R: '飛' };
  return (
    <div className="hero-board" aria-hidden="true">
      {cells.flat().map((p, i) => {
        const gote = i < 10;
        return (
          <div key={i} className="hb-cell">
            {p && <span className={`hb-koma jp ${gote ? 'gote' : ''} ${i === 18 ? 'hot' : ''}`}>{kanji[p]}</span>}
          </div>
        );
      })}
    </div>
  );
}

export default function HomePage() {
  const { lang, to, t } = useLang();
  const c = C[lang];
  const [waitingCount, setWaitingCount] = useState(0);

  useEffect(() => {
    let unsubscribe = () => {};
    try {
      unsubscribe = subscribeToWaitingPlayers((hasWaiting, count) => setWaitingCount(hasWaiting ? count || 1 : 0));
    } catch (error) {
      console.error('Lobi dinleme hatası:', error);
    }
    return () => {
      if (typeof unsubscribe === 'function') unsubscribe();
    };
  }, []);

  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: lang === 'en' ? 'Shogi Türkiye' : 'Şogi Türkiye',
      url: SITE_URL + to('home'),
      inLanguage: lang === 'en' ? 'en' : 'tr',
      description: c.seoDesc,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'Şogi Türkiye',
      url: SITE_URL,
      logo: `${SITE_URL}/android-icon-192x192.png`,
      sameAs: [SOCIAL.youtube, SOCIAL.instagram, PLAY_STORE_URL, CHROME_EXTENSION_URL],
    },
  ];

  const playCards = [
    { key: 'play', color: 'var(--c-play)', icon: '将', tags: ['easy', 'medium', 'hard', 'expert'] },
    { key: 'puzzles', color: 'var(--c-puzzle)', icon: '詰', tags: ['easy', 'medium', 'hard'] },
    { key: 'arena', color: 'var(--c-arena)', icon: '対', tags: [] },
    { key: 'academy', color: 'var(--c-academy)', icon: '学', tags: [] },
  ];

  return (
    <>
      <Seo title={c.seoTitle} description={c.seoDesc} jsonLd={jsonLd} />

      <section className="hero">
        <div className="container">
          <div className="row align-items-center g-4 g-lg-5">
            <div className="col-12 col-lg-7">
              <div className="eyebrow">{c.eyebrow}</div>
              <h1 className="mb-4">
                {c.h1a} <span className="marker">{c.h1b}</span>
                <br />
                {c.h1c}
              </h1>
              <p className="lead mb-4">{c.lead}</p>
              <div className="d-flex flex-wrap gap-2 mb-4">
                <Link to={to('play')} className="btn btn-ink btn-lg">{c.ctaPlay}</Link>
                <Link to={to('puzzles')} className="btn btn-soft btn-lg">{c.ctaPuzzle}</Link>
              </div>
              <div className="d-flex flex-wrap gap-2">
                {c.stats.map(([n, label]) => (
                  <div className="stat-tile" key={label}>
                    <b>{n.replace('{p}', String(PUZZLES.length))}</b>
                    <span>{label}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-12 col-lg-5 d-none d-md-block">
              <HeroBoard />
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-head">
            <h2 className="section-title" style={{ '--c': 'var(--c-play)' }}>{c.playTitle}</h2>
          </div>
          <div className="row g-3 g-md-4">
            {playCards.map(({ key, color, icon, tags }) => {
              const [title, desc, mode] = c.cards[key];
              return (
                <div className="col-12 col-sm-6 col-lg-3" key={key}>
                  <Link to={to(key)} className="game-card" style={{ '--c': color }}>
                    <span className="badge-mode">{mode}</span>
                    {key === 'arena' && waitingCount > 0 && (
                      <span className="tag medium pulse position-absolute" style={{ top: 48, right: 16 }}>
                        ● {c.waiting.replace('{n}', waitingCount)}
                      </span>
                    )}
                    <span className="icon jp">{icon}</span>
                    <h3>{title}</h3>
                    <p>{desc}</p>
                    {tags.length > 0 && (
                      <div className="tags">
                        {tags.map((lv) => <span key={lv} className={`tag ${lv}`}>{t(`level.${lv}`)}</span>)}
                      </div>
                    )}
                    <span className="link-arrow">{t('common.play')}</span>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="section pt-0">
        <div className="container">
          <div className="section-head">
            <h2 className="section-title" style={{ '--c': 'var(--c-learn)' }}>{c.learnTitle}</h2>
          </div>
          <div className="row g-3">
            {Object.entries(c.learn).map(([key, [title, desc]]) => (
              <div className="col-12 col-sm-6 col-lg-3" key={key}>
                <Link to={to(key)} className="game-card" style={{ '--c': 'var(--c-learn)', borderTopWidth: 4 }}>
                  <h3 className="h5 font-head">{title}</h3>
                  <p className="mb-2">{desc}</p>
                  <span className="link-arrow">{t('common.readMore')}</span>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section pt-0">
        <div className="container">
          <div className="promo-band">
            <span className="kanji-bg jp" aria-hidden="true">将棋</span>
            <div className="row align-items-center g-3 position-relative">
              <div className="col-12 col-lg-7">
                <h2 className="mb-2">{c.promoTitle}</h2>
                <p className="mb-0">{c.promoText}</p>
              </div>
              <div className="col-12 col-lg-5 d-flex flex-column align-items-lg-end gap-2">
                <StoreBadges medium="home_promo" />
                <Link to={to('apps')} className="text-white small fw-bold">{c.promoMore} →</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section pt-0">
        <div className="container">
          <div className="section-head">
            <h2 className="section-title" style={{ '--c': 'var(--c-academy)' }}>{c.aboutTitle}</h2>
          </div>
          <div className="row g-3">
            {c.about.map(([title, text]) => (
              <div className="col-12 col-lg-4" key={title}>
                <article className="panel h-100 prose">
                  <h3 className="h4">{title}</h3>
                  <p className="mb-0">{text}</p>
                </article>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
